import EFOcats_error_info from '../efocats_error_info.js';
import EFOcats_import_lang from '../import/efocats_import_lang.js';
import efocats_validate_core from './efocats_validate_core.js';

/**
 * telチェッククラス
 */
export default class EFOcats_validate_tel extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    if (checkData.attr('type') !== 'tel') {
      return new EFOcats_error_info('success', '', '', '');
    }

    const material_dataType = checkData.attr('data-type');
    let result;

    if (material_dataType === 'postal') {
      result = this.check_postal(checkData);
    } else if (material_dataType === 'birthday') {
      result = this.check_birthday(checkData);
    } else {
      result = this.check_tel(checkData);
    }

    return result;
  }

  /**
   * 生年月日チェック
   */
  check_birthday(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');
    this.rep_birthday(checkData);
    const split_val = checkData.val().split('/');
    const num_extraction_pattern = new RegExp(/[1-9１-９]/);
    if (checkData.val().match(num_extraction_pattern)) {
      // 存在しない日付を入れた場合はエラーにする
      if (split_val[1] <= 0 || split_val[1] > 12 || split_val[2] <= 0 || split_val[2] > 31) {
        result = new EFOcats_error_info('error', this.langagerList('生年月日エラー'), '', '生年月日エラー');
      }
    } else {
      result = new EFOcats_error_info('error', this.langagerList('生年月日エラー'), '', '生年月日エラー');
    }
    return result;
  }

  /**
   * 郵便番号チェック
   */
  check_postal(checkData) {
    const material_val = checkData.val();
    let result = new EFOcats_error_info('success', '', '', '');

    if (material_val.match(/^\d{3}-?\d{4}$/)) {
      result = new EFOcats_error_info('success', '', '', '');
    } else {
      result = new EFOcats_error_info('error', this.langagerList('郵便1エラー'), '', '郵便1エラー');
    }
    return result;
  }

  /**
   * 文字の挿入
   */
  strIns(str, idx, val) {
    const res = str.slice(0, idx) + val + str.slice(idx);
    return res;
  }

  /**
   * 電話番号チェック
   */
  check_tel(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');

    const mode = checkData.attr('cat-validate-tel');
    checkData.val(checkData.val().replace(/-|ー|－|－/g, ''));

    const tel_num = this.getFormatPhone(checkData.val());

    const mobile_prefix = ['050', '060', '070', '080', '090'];

    const name = this.getLabel(checkData);

    if (!checkData.val().match(/^[0-9-]*$/)) {
      // 文字種エラー
      const msg = EFOcats_import_lang.getValue('telcharerror', {name});
      result = new EFOcats_error_info('error', msg, '', msg);
    } else if (checkData.val() !== '' && (tel_num === undefined || tel_num === false)) {
      // フォーマットエラー
      const msg = EFOcats_import_lang.getValue('telerror', {name});
      result = new EFOcats_error_info('error', msg, '', msg);
    } else if (mode === 'mobile' && checkData.val() !== '' && !checkData.val().match(/^0[9876]0[-]?\d{4}[-]?\d{4}$/)) {
      // 携帯電話番号欄の接頭語チェック
      const msg = EFOcats_import_lang.getValue('telerror', {name});
      result = new EFOcats_error_info('error', msg, '', msg);
    } else if (this.checkPrefix(checkData.val())) {
      // 禁止接頭語のチェック
      const msg = EFOcats_import_lang.getValue('telerror', {name});
      result = new EFOcats_error_info('error', msg, '', msg);
    } else if (!mode && mobile_prefix.includes(checkData.val().substr(0, 3)) && checkData.val().length !== 11) {
      // 携帯電話番号欄でなく、050～090で開始する場合に11桁でない
      const msg = EFOcats_import_lang.getValue('tellengtherror', {name});
      result = new EFOcats_error_info('error', msg, '', msg);
    } else if (!mode && !mobile_prefix.includes(checkData.val().substr(0, 3)) && checkData.val().length !== 10) {
      // 携帯電話番号欄でなく、050～090で開始していない場合に10桁でない
      const msg = EFOcats_import_lang.getValue('tellengtherror', {name});
      result = new EFOcats_error_info('error', msg, '', msg);
    } else if (mode === 'mobile' && checkData.val().length !== 0 && checkData.val().length !== 11) {
      // 携帯番号欄で11桁でない
      const msg = EFOcats_import_lang.getValue('mobtellengtherror', {name});
      result = new EFOcats_error_info('error', msg, '', msg);
    }

    return result;
  }

  /**
   * 接頭語NGのチェック
   * @param {*} value
   * @returns
   */
  checkPrefix(value) {
    const prefix_ng = ['0120', '0800', '0990', '0180', '0570', '0170', '010', '020', '030', '040'];

    for (let index = 0; index < prefix_ng.length; index++) {
      const prefix = prefix_ng[index];
      if (value.indexOf(prefix) === 0) {
        return true;
      }
    }

    return false;
  }

  /**
   * エラーメッセージに埋め込むラベルを取得する
   * @param {*} checkData
   * @returns
   */
  getLabel(checkData) {
    let name = checkData.attr('cat-data-label');

    if (checkData.parents('.inner').prev(':not(.free-txt)').text().trim() !== '') {
      name = checkData.parents('.inner').prev().text().trim();
    } else if (checkData.parents('.container').children().eq(0).text().trim() !== '') {
      name = checkData.parents('.container').children().eq(0).text().trim();
    }

    return name;
  }
}
